<script setup>
import axios  from "axios";
import { parse } from 'js-html-parser';
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-dialog
        v-model="fav"
        width="700px"
    >
        <v-card
            width="700px"
        >
			<v-toolbar
				height="50px"
				flat
				color="#E13532"
				dark
			>
				<v-toolbar-title>
				お気に入り保存
				</v-toolbar-title>
				<v-spacer />
				<v-icon
					@click="fav=false"
					dark
				>
					mdi-close
				</v-icon>
			</v-toolbar>
            <v-card-text id="favblock">
                <v-row class="mt-5">
                    <v-col cols="1">
                        <span class="formlabel">名前</span>
                    </v-col>
                    <v-col>
                    <v-text-field
                      v-model="name"
                      hide-details="auto"
                      dense
                    ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-1">
					<v-col> 
						<p class="parea" v-html="currentHTML" />
					</v-col>
				</v-row>
            </v-card-text>
            <v-card-actions class="px-3 pb-5">
                <v-spacer />
                <v-btn
                    @click="save"
					color="#E13532"
					:dark="!disabled"
					:disabled="disabled"
                >
                    <v-icon>
                        mdi-content-save-edit
                    </v-icon>
                    名前をつけて保存
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data : function(){
        return {
            fav  : false,
            name : "",
			favobj : null,
			disabled : true,
			currentHTML : "",
        };
    },
	watch : {
		name : function(){
			if(this.name == "")
			{
				this.disabled = true;
			}
			else
			{
				this.disabled = false;
			}
		},
	},
	computed: {
        e_doc : function() {
            return this.$store.getters['doc_info/get_doc'];
        },
	},
    methods : {
        open : function(favobj){
            this.fav=true;
			this.favobj = favobj;
			let element=parse(this.e_doc);
			for(let cnt = 0 ; cnt < element.childNodes.length ; cnt++)
			{
				if(element.childNodes[cnt].id==this.favobj.id)
				{
					this.currentHTML = element.childNodes[cnt].innerHTML;
					break;
				}
			}
        },
        save : async function(){
            var params = new URLSearchParams();
            params.append("name",this.name);
			params.append("json",JSON.stringify(this.favobj));
            await axios.post("/api/release/set_favblock",params)
            .then(response => {
				this.$emit("updated",response.data);
				this.fav = false;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
}
</script>
